// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  dailyNews: (t, data?, options?) => t('enum.site-feature.daily-news.name', data, options),
  iknowIntegration: (t, data?, options?) => t('enum.site-feature.iknow-integration.name', data, options),
  materials: (t, data?, options?) => t('enum.site-feature.materials.name', data, options),
  meetings: (t, data?, options?) => t('enum.site-feature.meetings.name', data, options),
  users: (t, data?, options?) => t('enum.site-feature.users.name', data, options),
  wordsPage: (t, data?, options?) => t('enum.site-feature.words-page.name', data, options),
  /* eslint-enable max-len */
};
